import {Household} from './household';
import {Store} from './store';

export class Context {

  household: Household | null;

  constructor(h?: Household, s?: Store) {
    this.household = h;
  }

  public isSet(): boolean {
    return this.household !== null;
  }

}
